module.exports = __webpack_public_path__ + "static/logo_ticino-5e4e362fe500ecc9f193d749215988f5.png";